import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import { UIContext } from "./layout"
import Link from "./link"
import {
  ImageWrapper,
  MainText,
  LeftContainer,
  GridContainer
} from "./keyboard-divider.style"

const KeyboardDivider = ({ text, linkText, linkLocation }) => {
  const query = useStaticQuery(graphql`
    query {
      sm: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Mobile/blog_keyboard_mobile.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Tablet/blog_keyboard_tablet.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      lg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/blog_keyboard_cropped.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  const {
    state: { breakpoint },
  } = useContext(UIContext)

  return (
    <GridContainer>
      <ImageWrapper>
        <Img
          fluid={query[breakpoint].childImageSharp.fluid}
          alt=""
          imgStyle={{ objectFit: "contain" }}
        />
      </ImageWrapper>
      <LeftContainer>
        <MainText>{text}</MainText>
        <Link href={linkLocation}>
          {linkText}
        </Link>
      </LeftContainer>
    </GridContainer>
  )
}

export default KeyboardDivider
